import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core'
import { TooltipDirective } from '../../../directives/tooltip/tooltip.directive'
import { IconsDirective } from '@awork/_shared/directives/icons/icons.directive'
import { Size } from '@awork/_shared/types/size'
import type { ActionDropdownButtonSize, ActionDropdownButtonType } from './types'

@Component({
  selector: 'aw-action-dropdown-button',
  templateUrl: './action-dropdown-button.component.html',
  styleUrls: ['./action-dropdown-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TooltipDirective, IconsDirective]
})
export class ActionDropdownButtonComponent {
  readonly type = input<ActionDropdownButtonType>('border')
  readonly size = input<ActionDropdownButtonSize>(Size.m)
  readonly selected = input(false)
  readonly disabled = input(false)
  readonly tooltip = input<string>()
  readonly tooltipFromTop = input(false)

  readonly onClick = output<MouseEvent>()
  readonly buttonClasses = computed(() => this.buildButtonClasses())

  /**
   * Handle button click
   * @param {MouseEvent} event
   */
  onButtonClick(event: MouseEvent): void {
    if (!this.disabled()) {
      event.stopPropagation()
      this.onClick.emit(event)
    }
  }

  /**
   * Builds the CSS class string for the button
   * @returns {string} Space-separated CSS class string
   */
  private buildButtonClasses(): string {
    const classes: string[] = ['action-dropdown-button']

    classes.push(`action-dropdown-button--size-${this.size()}`)
    classes.push(`action-dropdown-button--${this.type()}`)

    if (this.selected()) {
      classes.push('action-dropdown-button--selected')
    }

    if (this.disabled()) {
      classes.push('action-dropdown-button--disabled')
    }

    return classes.join(' ')
  }
}
